<span *ngFor="let ansImage of AnswerImages" class="answer-opt-image" (click)="checkimageURL(ansImage?.imageURL,$event.target)">
  <span>
    <app-image-control [imageName]="ansImage?.imageName"
      [imagePath]="ansImage?.imagePath"
      [imagePath]="" [imageRedirectURL]="ansImage?.imageURL ? ansImage.imageURL : undefined ">
    </app-image-control>
  </span>
</span>

